import log from 'salvo-lite/log'
import 'dom-slider'

class Slide {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.getAttribute('data-slide'))
        this._elemToChange = this._data.elem
        this._action = this._data.action || null
        this._delay = this._data.delay || null
        this._maxWidth = this._data.maxWidth || 9999999
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            if (window.innerWidth <= this._maxWidth) {
                if (Array.isArray(this._elemToChange)) {
                    for (var i = 0; i < this._elemToChange.length; i++) {
                        this.function(this._elemToChange[i], this._action[i], i)
                    }
                } else {
                    this.function(this._elemToChange, this._action)
                }
            }
            if (this._data.closeSiblings) {
                this.closeSiblings(this._elemToChange)
            }
        })
    }

    function (element, action, count) {
        if (element === 'next') {
            element = this._elem.nextElementSibling
        } else if (element === 'parent') {
            element = this._elem.parentNode
        } else if (element === 'child') {
            element = this._elem.firstElementChild
        } else {
            element = document.querySelector(element)
        }

        if (this._delay && count > 0) {
            setTimeout(function () {
                if (action === 'show') {
                    element.slideDown()
                } else if (action === 'hide') {
                    element.slideUp()
                } else if (action === 'toggle') {
                    element.slideToggle()
                } else {
                    element.slideToggle()
                }
            }, this._delay)
        } else {
            if (action === 'show') {
                element.slideDown()
            } else if (action === 'hide') {
                element.slideUp()
            } else if (action === 'toggle') {
                element.slideToggle()
            } else {
                element.slideToggle()
            }
        }
    }

    closeSiblings (elem) {
        const siblings = document.querySelectorAll(this._data.closeSiblings)
        for (var i = 0; i < siblings.length; i++) {
            if (siblings[i] !== document.querySelector(elem)) {
                if (this._data.closeSiblingsElement) {
                    siblings[i].querySelector(this._data.closeSiblingsElement).slideUp()
                } else {
                    siblings[i].slideUp()
                }
            }
        }
    }
}

export default Slide



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slide.js